import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getWalletSummary } from '../lib/apiClient';
import { getLastSuccessfulSummary, setLastSuccessfulSummary } from '../lib/storage';
import type { WalletSummary } from '../lib/types';

export function useWalletSummary(address: string, label: string) {
  const previousRef = useRef<{ address: string; summary: WalletSummary | null }>({
    address,
    summary: getLastSuccessfulSummary(address),
  });

  if (previousRef.current.address !== address) {
    previousRef.current = { address, summary: getLastSuccessfulSummary(address) };
  }

  const query = useQuery({
    queryKey: ['wallet-summary', address, label],
    queryFn: () => getWalletSummary(address, label),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });

  useEffect(() => {
    if (query.data) {
      setLastSuccessfulSummary(address, query.data);
    }
  }, [query.data, address]);

  return { ...query, previousSummary: previousRef.current.summary };
}
